import { TableColumnDef } from "./Loop";



export const loopWidgetHander = (editorRef: any,
    onCallBack: (open: boolean, data: TableColumnDef, widgetId: string) => void
) => {
    (editorRef.current).on("click", (e: any) => {
            // Find table by data-widget-id
            const table = e.target.closest("[data-widget-id]");

            if (table) {
              e.preventDefault();
              e.stopPropagation();

              const columnsAttr = table.getAttribute("data-columns");
              const widgetId = table.getAttribute("data-widget-id");
              if (columnsAttr && widgetId) {
                const columns = JSON.parse(columnsAttr);
                onCallBack(true, columns, widgetId);

              }
            }
          });
}